import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/** Safe rendering of AI-produced text: markdown subset, no raw HTML, links open in a new tab. */
export function AIText({ text, className = "", testId }) {
  if (!text) return null;
  return (
    <div className={`ai-text text-sm leading-relaxed ${className}`} data-testid={testId}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={{
          a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" className="text-primary underline" />,
          h1: ({ node, ...props }) => <h4 className="font-semibold mt-3 mb-1" {...props} />,
          h2: ({ node, ...props }) => <h4 className="font-semibold mt-3 mb-1" {...props} />,
          h3: ({ node, ...props }) => <h4 className="font-semibold mt-3 mb-1" {...props} />,
          p: ({ node, ...props }) => <p className="mb-2 last:mb-0" {...props} />,
          ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-2 space-y-0.5" {...props} />,
          ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-2 space-y-0.5" {...props} />,
          strong: ({ node, ...props }) => <strong className="font-semibold text-foreground" {...props} />,
          code: ({ node, ...props }) => <code className="font-mono text-xs bg-muted px-1 rounded" {...props} />,
          table: ({ node, ...props }) => <div className="overflow-x-auto mb-2"><table className="text-xs border border-border" {...props} /></div>,
          th: ({ node, ...props }) => <th className="border border-border px-2 py-1 bg-muted text-left" {...props} />,
          td: ({ node, ...props }) => <td className="border border-border px-2 py-1 align-top" {...props} />,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
